import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "authEnterWith"
}
const _hoisted_2 = {
  key: 0,
  class: "authEnterWith_error"
}

import AcButton from '@ui-kit/components/AcButton.vue'
import AcDivider from '@ui-kit/components/AcDivider.vue'

import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@web/store'
import useTypesAuth from '@web/composition/useTypesAuth'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AuthEnterWith'
},
  __name: 'enter-with',
  props: {
  error: {
    type: String,
    default: ''
  }
},
  setup(__props) {





const store = useStore()
const router = useRouter()

const authOptions = computed(() => store.getters['authV3/getAuthOptions'])
const isVkIdAvailable = computed(() => authOptions.value?.vkIdAvailable)

const {
  onSelectType,
  clients
} = useTypesAuth({ router, action: 'login' })

const vkontakteClient = computed(() => clients.value.find(client => client.name === 'vkontakte'))

return (_ctx: any,_cache: any) => {
  return (isVkIdAvailable.value && vkontakteClient.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(AcDivider, { class: "authEnterWith_divider" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('partsSpeech.or')), 1)
          ]),
          _: 1
        }),
        _createVNode(AcButton, {
          class: "authEnterWith_button-enter-with",
          variant: "outlined",
          color: "gray",
          block: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onSelectType)(vkontakteClient.value)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(["authEnterWith_button-enter-with_icon", `-${vkontakteClient.value.name}`])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('enterWith')) + " VK ID ", 1)
          ]),
          _: 1
        }),
        (__props.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.error), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})